import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell, CheckCheck, Settings2 } from 'lucide-react';
import api from '../utils/api';
import NotificationSettings from '../components/NotificationSettings';

/* El listado completo de avisos. Lo mismo que muestra el panel de la campana,
   pero entero y con espacio para leer. */

const AR = -3 * 3600 * 1000;
const cuando = (t) => {
  const d = new Date(t);
  const min = Math.round((Date.now() - d.getTime()) / 60000);
  if (min < 1) return 'recién';
  if (min < 60) return `hace ${min} min`;
  if (min < 60 * 24) return `hace ${Math.round(min / 60)} h`;
  const f = new Date(d.getTime() + AR).toISOString().slice(0, 10).split('-').reverse();
  return `${f[0]}/${f[1]}`;
};

export default function Notificaciones() {
  const [items, setItems] = useState(null);
  const [config, setConfig] = useState(false);
  const navigate = useNavigate();

  const cargar = () => api.get('/notifications')
    .then(r => setItems(r.data.items || []))
    .catch(() => setItems([]));
  useEffect(() => { cargar(); }, []);

  const leerTodas = async () => {
    await api.post('/notifications/read', {}).catch(() => {});
    setItems(is => is.map(i => ({ ...i, read_at: i.read_at || new Date().toISOString() })));
  };

  const abrir = (n) => {
    if (!n.read_at) api.post('/notifications/read', { id: n.id }).catch(() => {});
    if (n.url) navigate(n.url);
  };

  const sinLeer = (items || []).filter(n => !n.read_at).length;

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap', marginBottom: 22 }}>
        <div>
          <div className="encabezado-eyebrow">Avisos</div>
          <h1 className="encabezado-titulo">Notificaciones</h1>
          <div className="encabezado-linea" />
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {sinLeer > 0 && (
            <button className="btn btn-secondary btn-sm" onClick={leerTodas}>
              <CheckCheck size={15} /> Marcar todas como leídas
            </button>
          )}
          <button className="btn btn-ghost btn-sm" onClick={() => setConfig(true)}>
            <Settings2 size={15} /> Configurar
          </button>
        </div>
      </div>

      {!items ? <div className="card" style={{ color: 'var(--text-muted)' }}>Cargando...</div>
        : items.length === 0 ? (
          <div className="card" style={{ textAlign: 'center', padding: '50px 20px', color: 'var(--text-muted)' }}>
            <Bell size={34} style={{ opacity: 0.35, marginBottom: 12 }} />
            <div style={{ fontSize: 15, color: 'var(--text-secondary)' }}>No tenés notificaciones</div>
            <div style={{ fontSize: 13, marginTop: 4 }}>Acá van a aparecer los avisos de la plataforma.</div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {items.map(n => (
              <div key={n.id} onClick={() => abrir(n)} className="aviso-fila"
                style={{ cursor: n.url ? 'pointer' : 'default', background: n.read_at ? 'var(--bg-card)' : 'var(--accent-glow)' }}>
                <span className="aviso-punto" style={{ background: n.read_at ? 'transparent' : 'var(--accent)' }} />
                <div style={{ minWidth: 0, flex: 1 }}>
                  <div style={{ fontSize: 14, fontWeight: n.read_at ? 600 : 700 }}>{n.title}</div>
                  {n.body && <div style={{ fontSize: 13, color: 'var(--text-secondary)', marginTop: 3, whiteSpace: 'pre-line', lineHeight: 1.55 }}>{n.body}</div>}
                  <div style={{ fontSize: 11.5, color: 'var(--text-muted)', marginTop: 5 }}>{cuando(n.created_at)}</div>
                </div>
              </div>
            ))}
          </div>
        )}

      {config && <NotificationSettings onClose={() => setConfig(false)} />}
    </div>
  );
}
